module.exports = __webpack_public_path__ + "img/centerWhite.c00e43d4.svg";